import React, { Component } from 'react';
import {
  Modal,
  Icon,
  Popup,
  Item,
} from 'semantic-ui-react';
import cx from 'classnames';
import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Update from 'immutability-helper';
import { observer, inject } from 'mobx-react';
import WithRouter from '../Extensions/WithRouter';
import api from '../../api';
import Loader from '../Loader/Loader';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import SecurityDetailModal from './SecurityDetailModal';
import LitigatorDetailModal from './LitigatorDetailModal';

class CompareModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenCPM: props.isOpenCPM,
      isOpenMSD: false,
      isOpenMLD: false,
      compareResult: props.compareResult,
      isCompareLoading: props.isCompareLoading,
      pageSize: 25,
      cveData: {},
      litigatorData: {},
      selectedCode: '',
    };
    this.closeModal = this.closeModal.bind(this);
    this.handleComponentScroll = this.handleComponentScroll.bind(this);
    this.handleSecurityScroll = this.handleSecurityScroll.bind(this);
    this.handleLicenseScroll = this.handleLicenseScroll.bind(this);
    this.handleLitigatorScroll = this.handleLitigatorScroll.bind(this);
    this.handlePolicyScroll = this.handlePolicyScroll.bind(this);
    this.handleMSDClose = this.handleMSDClose.bind(this);
    this.handleMLDClose = this.handleMLDClose.bind(this);
    this.handleSecurityDetailModal = this.handleSecurityDetailModal.bind(this);
    this.handleLitigatorDetailModal = this.handleLitigatorDetailModal.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.compare_popup .setting_popup_content_wrap .compare_box span', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.compare_popup .setting_popup_content_wrap .compare_box_2 span', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { isCompareLoading, compareResult, isOpenCPM } = this.props;
    if (prevProps.isCompareLoading !== isCompareLoading) {
      this.setState({
        isCompareLoading,
      });
    }
    if (prevProps.compareResult !== compareResult) {
      this.setState({
        compareResult,
      });
    }

    if (prevProps.isOpenCPM !== isOpenCPM) {
      this.setState({
        isOpenCPM,
      });
    }
  }

  handleMSDClose() {
    this.setState({
      isOpenMSD: false,
    });
  }

  handleMLDClose() {
    this.setState({
      isOpenMLD: false,
    });
  }

  handleSecurityDetailModal(e, value) {
    const data = {
      security_name: value,
    };
    api.getComponentSecurityDetail(data)
      .then((response) => {
        this.setState({
          cveData: response.response,
          selectedCode: value,
          isOpenMSD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleLitigatorDetailModal(e, string) {
    let value;
    if (string.indexOf('SFC') > -1) {
      value = 'Software Freedom Conservancy';
    } else if (string.indexOf('McHardy') > -1) {
      value = 'Patrick McHardy';
    } else if (string.indexOf('Patent') > -1) {
      value = 'Patents';
    }

    if (!value) {
      value = string;
    }

    const data = {
      litigator_name: value,
    };
    api.getComponentLitigatorDetail(data)
      .then((response) => {
        this.setState({
          litigatorData: response.response,
          isOpenMLD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getCompareComponent = (pageNo, limit) => {
    const { compareResult, pageSize } = this.state;
    const page = pageNo || 2;
    const perPage = limit || pageSize;

    api
      .getCompareComponent(
        {
          source_id: compareResult.source_id,
          target_id: compareResult.target_id,
          page,
          limit: perPage,
        }
      )
      .then((response) => {
        const nextComponentList = response.response;
        this.setState({
          compareResult: Update(compareResult, {
            components: {
              list: {
                $push: nextComponentList,
              },
              pagination: {
                $set: response.pagination,
              },
            },
          }),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getCompareSecurity = (pageNo, limit) => {
    const { compareResult, pageSize } = this.state;
    const page = pageNo || 2;
    const perPage = limit || pageSize;

    api
      .getCompareSecurity(
        {
          source_id: compareResult.source_id,
          target_id: compareResult.target_id,
          page,
          limit: perPage,
        }
      )
      .then((response) => {
        const nextSecurityList = response.response;
        this.setState({
          compareResult: Update(compareResult, {
            securities: {
              list: {
                $push: nextSecurityList,
              },
              pagination: {
                $set: response.pagination,
              },
            },
          }),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getCompareLicense = (pageNo, limit) => {
    const { compareResult, pageSize } = this.state;
    const page = pageNo || 2;
    const perPage = limit || pageSize;

    api
      .getCompareLicense(
        {
          source_id: compareResult.source_id,
          target_id: compareResult.target_id,
          page,
          limit: perPage,
        }
      )
      .then((response) => {
        const nextLicenseList = response.response;
        this.setState({
          compareResult: Update(compareResult, {
            licenses: {
              list: {
                $push: nextLicenseList,
              },
              pagination: {
                $set: response.pagination,
              },
            },
          }),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getCompareLitigator = (pageNo, limit) => {
    const { compareResult, pageSize } = this.state;
    const page = pageNo || 2;
    const perPage = limit || pageSize;

    api
      .getCompareLitigator(
        {
          source_id: compareResult.source_id,
          target_id: compareResult.target_id,
          page,
          limit: perPage,
        }
      )
      .then((response) => {
        const nextLitigatorList = response.response;
        this.setState({
          compareResult: Update(compareResult, {
            litigators: {
              list: {
                $push: nextLitigatorList,
              },
              pagination: {
                $set: response.pagination,
              },
            },
          }),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getComparePolicy = (pageNo, limit) => {
    const { compareResult, pageSize } = this.state;
    const page = pageNo || 2;
    const perPage = limit || pageSize;

    api
      .getComparePolicy(
        {
          source_id: compareResult.source_id,
          target_id: compareResult.target_id,
          page,
          limit: perPage,
        }
      )
      .then((response) => {
        const nextPolicyList = response.response;
        this.setState({
          compareResult: Update(compareResult, {
            policies: {
              list: {
                $push: nextPolicyList,
              },
              pagination: {
                $set: response.pagination,
              },
            },
          }),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleComponentScroll = (event) => {
    const {
      getCompareComponent,
      state: { compareResult },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (!compareResult.components.pagination.next) {
      return;
    }
    if (scrolledToBottom) {
      getCompareComponent(compareResult.components.pagination.current + 1);
    }
  };

  handleSecurityScroll = (event) => {
    const {
      getCompareSecurity,
      state: { compareResult },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    if (!compareResult.securities.pagination.next) {
      return;
    }
    if (scrolledToBottom) {
      getCompareSecurity(compareResult.securities.pagination.current + 1);
    }
  };

  handleLicenseScroll = (event) => {
    const {
      getCompareLicense,
      state: { compareResult },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (!compareResult.licenses.pagination.next) {
      return;
    }
    if (scrolledToBottom) {
      getCompareLicense(compareResult.licenses.pagination.current + 1);
    }
  };

  handleLitigatorScroll = (event) => {
    const {
      getCompareLitigator,
      state: { compareResult },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (!compareResult.litigators.pagination.next) {
      return;
    }
    if (scrolledToBottom) {
      getCompareLitigator(compareResult.litigators.pagination.current + 1);
    }
  };

  handlePolicyScroll = (event) => {
    const {
      getComparePolicy,
      state: { compareResult },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (!compareResult.policies.pagination.next) {
      return;
    }
    if (scrolledToBottom) {
      getComparePolicy(compareResult.policies.pagination.current + 1);
    }
  };

  closeModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  render() {
    const {
      compareResult,
      cveData,
      litigatorData,
      isOpenCPM,
      isOpenMSD,
      isOpenMLD,
      selectedCode,
      isCompareLoading,
    } = this.state;
    const { state, translate } = this.props;

    const tooltipStyle = {
      fontSize: '11px',
      fontWeight: '500',
    };

    if (state.user.scanConfig.isLoading) {
      return <Loader />;
    }

    return (
      <Modal open={isOpenCPM} onClose={this.closeModal}>
        <div className="setting_popup_wrap">
          <div className="setting_popup default_popup compare_popup">
            <div className="setting_popup_header">
              <h2 className="popup_name">
                {translate('contents_header.menu.compare_scan_results')}
              </h2>
              <a className="popup_close_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                <img src={closeBtn} alt="" style={{ cursor: 'pointer' }} />
              </a>
            </div>
            {
              !isCompareLoading && compareResult.source_date ? (
                <div className="popup_scroll">
                  <div className="setting_popup_contnets">
                    <div className="setting_popup_content_wrap">
                      <table className="table">
                        <colgroup>
                          <col style={{ width: '50%' }} />
                          <col style={{ width: '50%' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td className="">
                              <div className="bg_red round compare_box">
                                <table className="compare_view">
                                  <colgroup>
                                    <col style={{ width: '55%' }} />
                                    <col style={{ width: '45%' }} />
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <Item.Group>
                                          <Item className="title">
                                            <Item.Header style={{ display: 'flex', alignItems: 'center' }}>
                                              <Icon className="file outline" style={{ width: '16px', flexShrink: 0, marginRight: '10px' }} />
                                              <span
                                                style={{
                                                  flexGrow: 1,
                                                  whiteSpace: 'nowrap',
                                                  overflow: 'hidden',
                                                  textOverflow: 'ellipsis',
                                                  marginRight: '10px',
                                                }}
                                              >
                                                {compareResult.source_name}
                                              </span>
                                              <span>
                                                {
                                                  compareResult.source_precision_level === 'narrow'
                                                  && (
                                                    <Popup
                                                      trigger={(
                                                        <a className="icon_box">
                                                          <Icon
                                                            name="arrow alternate circle up"
                                                            color="green"
                                                            style={{ width: '16px', flexShrink: 0 }}
                                                          />
                                                        </a>
                                                      )}
                                                      content={translate('modal.content.precision_level_narrow')}
                                                      inverted
                                                      position="bottom left"
                                                      style={tooltipStyle}
                                                    />
                                                  )
                                                }
                                                {
                                                  compareResult.source_precision_level === 'medium'
                                                  && (
                                                    <Popup
                                                      trigger={(
                                                        <a className="icon_box">
                                                          <Icon
                                                            name="exchange"
                                                            color="blue"
                                                            style={{ width: '16px', flexShrink: 0 }}
                                                          />
                                                        </a>
                                                      )}
                                                      content={translate('modal.content.precision_level_medium')}
                                                      inverted
                                                      position="bottom left"
                                                      style={tooltipStyle}
                                                    />
                                                  )
                                                }
                                                {
                                                  compareResult.source_precision_level === 'broad'
                                                  && (
                                                    <Popup
                                                      trigger={(
                                                        <a className="icon_box">
                                                          <Icon
                                                            name="arrow alternate circle down"
                                                            color="red"
                                                            style={{ width: '16px', flexShrink: 0 }}
                                                          />
                                                        </a>
                                                      )}
                                                      content={translate('modal.content.precision_level_broad')}
                                                      inverted
                                                      position="bottom left"
                                                      style={tooltipStyle}
                                                    />
                                                  )
                                                }
                                              </span>
                                            </Item.Header>
                                          </Item>
                                          <Item className="info">
                                            <Item.Header>
                                              {translate('modal.scan_info.project_name')}
                                              :
                                            </Item.Header>
                                            <Item.Content><span>{compareResult.source_project_name}</span></Item.Content>
                                          </Item>
                                          <Item className="info">
                                            <Item.Header>
                                              {translate('modal.scan_info.project_version')}
                                              :
                                            </Item.Header>
                                            <Item.Content><span>{compareResult.source_project_version_name}</span></Item.Content>
                                          </Item>
                                          <Item className="info">
                                            <Item.Header>
                                              {translate('modal.scan_info.owner')}
                                              :
                                            </Item.Header>
                                            <Item.Content><span>{compareResult.source_owner}</span></Item.Content>
                                          </Item>
                                        </Item.Group>
                                      </td>
                                      <td>
                                        <Item.Group>
                                          <Item className="info">
                                            <Item.Header>
                                              {translate('modal.scan_info.completed')}
                                              :
                                            </Item.Header>
                                            <Item.Content>{compareResult.source_date}</Item.Content>
                                          </Item>
                                          <Item className="version">
                                            <Item.Header>
                                              {translate('modal.scan_info.clarity_version')}
                                              :
                                            </Item.Header>
                                            <Item.Content>{compareResult.source_versions.clarity}</Item.Content>
                                          </Item>
                                          <Item className="version">
                                            <Item.Header>
                                              {translate('modal.scan_info.oss_db_version')}
                                              :
                                            </Item.Header>
                                            <Item.Content>{compareResult.source_versions.oss}</Item.Content>
                                          </Item>
                                          <Item className="version">
                                            <Item.Header>
                                              {translate('modal.scan_info.security_db_version')}
                                              :
                                            </Item.Header>
                                            <Item.Content>{compareResult.source_versions.security}</Item.Content>
                                          </Item>
                                          {
                                            typeof Object.keys(compareResult.source_scan_option) !== 'undefined' && Object.keys(compareResult.source_scan_option).length !== 0 ? (
                                              Object.keys(compareResult.source_scan_option).map((item) => {
                                                if (Array.isArray(compareResult.source_scan_option[item])) {
                                                  return (
                                                    <Item key={uuidv4()} className="version">
                                                      <Item.Header>{item === 'scanfile' ? translate('modal.scan_info.file') : translate('modal.scan_info.language')}</Item.Header>
                                                      <Item.Content>{compareResult.source_scan_option[item].join(', ')}</Item.Content>
                                                    </Item>
                                                  );
                                                }
                                                return null;
                                              })
                                            ) : null
                                          }
                                        </Item.Group>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                            <td className="">
                              <div className="bg_green round compare_box">
                                <table className="compare_view">
                                  <colgroup>
                                    <col style={{ width: '55%' }} />
                                    <col style={{ width: '45%' }} />
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <Item.Group>
                                          <Item className="title">
                                            <Item.Header style={{ display: 'flex', alignItems: 'center' }}>
                                              <Icon className="file outline" style={{ width: '16px', flexShrink: 0, marginRight: '10px' }} />
                                              <span
                                                style={{
                                                  flexGrow: 1,
                                                  whiteSpace: 'nowrap',
                                                  overflow: 'hidden',
                                                  textOverflow: 'ellipsis',
                                                  marginRight: '10px',
                                                }}
                                              >
                                                {compareResult.target_name}
                                              </span>
                                              <span>
                                                {
                                                  compareResult.target_precision_level === 'narrow'
                                                  && (
                                                    <Popup
                                                      trigger={(
                                                        <a className="icon_box">
                                                          <Icon
                                                            name="arrow alternate circle up"
                                                            color="green"
                                                            style={{ width: '16px', flexShrink: 0 }}
                                                          />
                                                        </a>
                                                      )}
                                                      content={translate('modal.content.precision_level_narrow')}
                                                      inverted
                                                      position="bottom left"
                                                      style={tooltipStyle}
                                                    />
                                                  )
                                                }
                                                {
                                                  compareResult.target_precision_level === 'medium'
                                                  && (
                                                    <Popup
                                                      trigger={(
                                                        <a className="icon_box">
                                                          <Icon
                                                            name="exchange"
                                                            color="blue"
                                                            style={{ width: '16px', flexShrink: 0 }}
                                                          />
                                                        </a>
                                                      )}
                                                      content={translate('modal.content.precision_level_medium')}
                                                      inverted
                                                      position="bottom left"
                                                      style={tooltipStyle}
                                                    />
                                                  )
                                                }
                                                {
                                                  compareResult.target_precision_level === 'broad'
                                                  && (
                                                    <Popup
                                                      trigger={(
                                                        <a className="icon_box">
                                                          <Icon
                                                            name="arrow alternate circle down"
                                                            color="red"
                                                            style={{ width: '16px', flexShrink: 0 }}
                                                          />
                                                        </a>
                                                      )}
                                                      content={translate('modal.content.precision_level_broad')}
                                                      inverted
                                                      position="bottom left"
                                                      style={tooltipStyle}
                                                    />
                                                  )
                                                }
                                              </span>
                                            </Item.Header>
                                          </Item>
                                          <Item className="info">
                                            <Item.Header>
                                              {translate('modal.scan_info.project_name')}
                                              :
                                            </Item.Header>
                                            <Item.Content><span>{compareResult.target_project_name}</span></Item.Content>
                                          </Item>
                                          <Item className="info">
                                            <Item.Header>
                                              {translate('modal.scan_info.project_version')}
                                              :
                                            </Item.Header>
                                            <Item.Content><span>{compareResult.target_project_version_name}</span></Item.Content>
                                          </Item>
                                          <Item className="info">
                                            <Item.Header>
                                              {translate('modal.scan_info.owner')}
                                              :
                                            </Item.Header>
                                            <Item.Content><span>{compareResult.target_owner}</span></Item.Content>
                                          </Item>
                                        </Item.Group>
                                      </td>
                                      <td>
                                        <Item.Group>
                                          <Item className="info">
                                            <Item.Header>
                                              {translate('modal.scan_info.completed')}
                                              :
                                            </Item.Header>
                                            <Item.Content>{compareResult.target_date}</Item.Content>
                                          </Item>
                                          <Item className="version">
                                            <Item.Header>
                                              {translate('modal.scan_info.clarity_version')}
                                              :
                                            </Item.Header>
                                            <Item.Content>{compareResult.target_versions.clarity}</Item.Content>
                                          </Item>
                                          <Item className="version">
                                            <Item.Header>
                                              {translate('modal.scan_info.oss_db_version')}
                                              :
                                            </Item.Header>
                                            <Item.Content>{compareResult.target_versions.oss}</Item.Content>
                                          </Item>
                                          <Item className="version">
                                            <Item.Header>
                                              {translate('modal.scan_info.security_db_version')}
                                              :
                                            </Item.Header>
                                            <Item.Content>{compareResult.target_versions.security}</Item.Content>
                                          </Item>
                                          {
                                            typeof Object.keys(compareResult.target_scan_option) !== 'undefined' && Object.keys(compareResult.target_scan_option).length !== 0 ? (
                                              Object.keys(compareResult.target_scan_option).map((item) => {
                                                if (Array.isArray(compareResult.target_scan_option[item])) {
                                                  return (
                                                    <Item key={uuidv4()} className="version">
                                                      <Item.Header>{item === 'scanfile' ? translate('modal.scan_info.file') : translate('modal.scan_info.language')}</Item.Header>
                                                      <Item.Content>{compareResult.target_scan_option[item].join(', ')}</Item.Content>
                                                    </Item>
                                                  );
                                                }
                                                return null;
                                              })
                                            ) : null
                                          }
                                        </Item.Group>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="setting_popup_content_wrap">
                      <table className="table">
                        <colgroup>
                          <col style={{ width: '14.3%' }} />
                          <col style={{ width: '30%' }} />
                          <col style={{ width: '27%' }} />
                          <col style={{ width: '14.3%' }} />
                          <col style={{ width: '14.3%' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th>
                              {translate('modal.title.component')}
                              (
                              {compareResult.components.summary.total}
                              )
                            </th>
                            <th>
                              {translate('modal.title.security_risk')}
                              (
                              {compareResult.securities.summary.total}
                              )
                            </th>
                            <th>
                              {translate('modal.title.license')}
                              (
                              {compareResult.licenses.summary.total}
                              )
                            </th>
                            <th>
                              {translate('modal.title.litigator')}
                              (
                              {compareResult.litigators.summary.total}
                              )
                            </th>
                            <th>
                              {translate('modal.title.policy')}
                              (
                              {compareResult.policies.summary.total}
                              )
                            </th>
                          </tr>
                          <tr>
                            <td>
                              <div className="compare_table_wrap">
                                <table className="table compare_table">
                                  <colgroup>
                                    <col style={{ width: '50%' }} />
                                    <col style={{ width: '50%' }} />
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td className="bg_red">
                                        {compareResult.components.summary.source}
                                      </td>
                                      <td className="bg_green">
                                        {compareResult.components.summary.target}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="2">
                                        <strong>{compareResult.components.summary.common}</strong>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                            <td>
                              <div className="compare_table_wrap">
                                <table className="table compare_table">
                                  <colgroup>
                                    <col style={{ width: '50%' }} />
                                    <col style={{ width: '50%' }} />
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td className="bg_red">
                                        <div className="belt_chart">
                                          <div className="red">{compareResult.securities.summary.source_critical}</div>
                                          <div className="orange">{compareResult.securities.summary.source_high}</div>
                                          <div className="cheese">{compareResult.securities.summary.source_medium}</div>
                                          <div className="yellow">{compareResult.securities.summary.source_low}</div>
                                        </div>
                                      </td>
                                      <td className="bg_green">
                                        <div className="belt_chart">
                                          <div className="red">{compareResult.securities.summary.target_critical}</div>
                                          <div className="orange">{compareResult.securities.summary.target_high}</div>
                                          <div className="cheese">{compareResult.securities.summary.target_medium}</div>
                                          <div className="yellow">{compareResult.securities.summary.target_low}</div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="2">
                                        <strong>
                                          <div className="belt_chart">
                                            <div className="red">{compareResult.securities.summary.common_critical}</div>
                                            <div className="orange">{compareResult.securities.summary.common_high}</div>
                                            <div className="cheese">{compareResult.securities.summary.common_medium}</div>
                                            <div className="yellow">{compareResult.securities.summary.common_low}</div>
                                          </div>
                                        </strong>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                            <td>
                              <div className="compare_table_wrap">
                                <table className="table compare_table">
                                  <colgroup>
                                    <col style={{ width: '50%' }} />
                                    <col style={{ width: '50%' }} />
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td className="bg_red">
                                        <div className="belt_chart round">
                                          <div className="red">{compareResult.licenses.summary.source_protective}</div>
                                          <div className="cheese">{compareResult.licenses.summary.source_permissive}</div>
                                          <div className="yellow">{compareResult.licenses.summary.source_others}</div>
                                        </div>
                                      </td>
                                      <td className="bg_green">
                                        <div className="belt_chart round">
                                          <div className="red">{compareResult.licenses.summary.target_protective}</div>
                                          <div className="cheese">{compareResult.licenses.summary.target_permissive}</div>
                                          <div className="yellow">{compareResult.licenses.summary.target_others}</div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="2">
                                        <strong>
                                          <div className="belt_chart round">
                                            <div className="red">{compareResult.licenses.summary.common_protective}</div>
                                            <div className="cheese">{compareResult.licenses.summary.common_permissive}</div>
                                            <div className="yellow">{compareResult.licenses.summary.common_others}</div>
                                          </div>
                                        </strong>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                            <td>
                              <div className="compare_table_wrap">
                                <table className="table compare_table">
                                  <colgroup>
                                    <col style={{ width: '50%' }} />
                                    <col style={{ width: '50%' }} />
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td className="bg_red">
                                        {compareResult.litigators.summary.source}
                                      </td>
                                      <td className="bg_green">
                                        {compareResult.litigators.summary.target}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="2">
                                        <strong>{compareResult.litigators.summary.common}</strong>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                            <td>
                              <div className="compare_table_wrap">
                                <table className="table compare_table">
                                  <colgroup>
                                    <col style={{ width: '50%' }} />
                                    <col style={{ width: '50%' }} />
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td className="bg_red">
                                        {compareResult.policies.summary.source}
                                      </td>
                                      <td className="bg_green">
                                        {compareResult.policies.summary.target}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="2">
                                        <strong>{compareResult.policies.summary.common}</strong>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="table" style={{ marginTop: '10px' }}>
                        <colgroup>
                          <col style={{ width: '14.3%' }} />
                          <col style={{ width: '30%' }} />
                          <col style={{ width: '27%' }} />
                          <col style={{ width: '14.3%' }} />
                          <col style={{ width: '14.3%' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td>
                              <div className="compare_box_2">
                                <div className="compare_box_header">
                                  <h4>
                                    <div className="block">
                                      {translate('modal.title.component_name')}
                                    </div>
                                  </h4>
                                </div>
                                <div style={{ height: '206px' }}>
                                  <Scrollbars
                                    style={{
                                      overflow: 'hidden',
                                      position: 'relative',
                                      height: '84%'
                                    }}
                                    renderTrackHorizontal={() => {
                                      return <div />;
                                    }}
                                    renderThumbHorizontal={() => {
                                      return <div />;
                                    }}
                                    onScroll={this.handleComponentScroll}
                                  >
                                    <ul>
                                      {
                                        compareResult.components.list.map((item) => {
                                          return (
                                            <li
                                              className={cx({
                                                bg_red: item.belonged_to === 'source',
                                                bg_green: item.belonged_to === 'target',
                                              })}
                                              key={uuidv4()}
                                            >
                                              <span className="strong">{item.name}</span>
                                              <span>{item.version}</span>
                                            </li>
                                          );
                                        })
                                      }
                                    </ul>
                                  </Scrollbars>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="compare_box_2">
                                <div className="compare_box_header">
                                  <h4>
                                    <div className="block block_4">
                                      {translate('modal.title.cvss_score')}
                                    </div>
                                    <div className="block block_4">
                                      {translate('modal.title.cve_code')}
                                    </div>
                                  </h4>
                                </div>
                                <div style={{ height: '206px' }}>
                                  <Scrollbars
                                    style={{
                                      overflow: 'hidden',
                                      position: 'relative',
                                      height: '84%'
                                    }}
                                    renderTrackHorizontal={() => {
                                      return <div />;
                                    }}
                                    renderThumbHorizontal={() => {
                                      return <div />;
                                    }}
                                    onScroll={this.handleSecurityScroll}
                                  >
                                    <ul>
                                      {
                                        compareResult.securities.list.map((item) => {
                                          return (
                                            <li
                                              className={cx({
                                                bg_red: item.belonged_to === 'source',
                                                bg_green: item.belonged_to === 'target',
                                              })}
                                              key={uuidv4()}
                                            >
                                              <div className="block block_4">
                                                {item.score}
                                              </div>
                                              {
                                                item.risk === 'critical'
                                                  && (
                                                    <div className="block block_4 bullet bullet_red has_link" onClick={(e) => { return this.handleSecurityDetailModal(e, item.name); }} onKeyUp={(e) => { return this.handleSecurityDetailModal(e, item.name); }}>
                                                      <span>{item.name}</span>
                                                    </div>
                                                  )
                                              }
                                              {
                                                item.risk === 'high'
                                                  && (
                                                    <div className="block block_4 bullet bullet_orange has_link" onClick={(e) => { return this.handleSecurityDetailModal(e, item.name); }} onKeyUp={(e) => { return this.handleSecurityDetailModal(e, item.name); }}>
                                                      <span>{item.name}</span>
                                                    </div>
                                                  )
                                              }
                                              {
                                                item.risk === 'medium'
                                                  && (
                                                    <div className="block block_4 bullet bullet_cheese has_link" onClick={(e) => { return this.handleSecurityDetailModal(e, item.name); }} onKeyUp={(e) => { return this.handleSecurityDetailModal(e, item.name); }}>
                                                      <span>{item.name}</span>
                                                    </div>
                                                  )
                                              }
                                              {
                                                item.risk === 'low'
                                                  && (
                                                    <div className="block block_4 bullet bullet_yellow has_link" onClick={(e) => { return this.handleSecurityDetailModal(e, item.name); }} onKeyUp={(e) => { return this.handleSecurityDetailModal(e, item.name); }}>
                                                      <span>{item.name}</span>
                                                    </div>
                                                  )
                                              }
                                            </li>
                                          );
                                        })
                                      }
                                    </ul>
                                  </Scrollbars>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="compare_box_2">
                                <div className="compare_box_header">
                                  <h4>
                                    <div className="block">
                                      {translate('modal.title.license_name')}
                                    </div>
                                  </h4>
                                </div>
                                <div style={{ height: '206px' }}>
                                  <Scrollbars
                                    style={{
                                      overflow: 'hidden',
                                      position: 'relative',
                                      height: '84%'
                                    }}
                                    renderTrackHorizontal={() => {
                                      return <div />;
                                    }}
                                    renderThumbHorizontal={() => {
                                      return <div />;
                                    }}
                                    onScroll={this.handleLicenseScroll}
                                  >
                                    <ul>
                                      {
                                        compareResult.licenses.list.map((item) => {
                                          return (
                                            <li
                                              className={cx({
                                                bg_red: item.belonged_to === 'source',
                                                bg_green: item.belonged_to === 'target',
                                              })}
                                              key={uuidv4()}
                                            >
                                              {item.family === 'protective'
                                                && (
                                                  <div className="block bullet bullet_red bullet_disk">
                                                    {item.name}
                                                  </div>
                                                )}
                                              {item.family === 'permissive'
                                                && (
                                                  <div className="block bullet bullet_orange bullet_disk">
                                                    {item.name}
                                                  </div>
                                                )}
                                              {item.family === 'others'
                                                && (
                                                  <div className="block bullet bullet_yellow bullet_disk">
                                                    {item.name}
                                                  </div>
                                                )}
                                            </li>
                                          );
                                        })
                                      }
                                    </ul>
                                  </Scrollbars>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="compare_box_2">
                                <div className="compare_box_header">
                                  <h4>
                                    <div className="block">
                                      {translate('modal.title.litigator_name')}
                                    </div>
                                  </h4>
                                </div>
                                <div style={{ height: '206px' }}>
                                  <Scrollbars
                                    style={{
                                      overflow: 'hidden',
                                      position: 'relative',
                                      height: '84%'
                                    }}
                                    renderTrackHorizontal={() => {
                                      return <div />;
                                    }}
                                    renderThumbHorizontal={() => {
                                      return <div />;
                                    }}
                                    onScroll={this.handleLitigatorScroll}
                                  >
                                    <ul>
                                      {
                                        compareResult.litigators.list.map((item) => {
                                          return (
                                          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                                            <li
                                              className={cx('lit has_link', {
                                                bg_red: item.belonged_to === 'source',
                                                bg_green: item.belonged_to === 'target',
                                              })}
                                              key={uuidv4()}
                                              style={{
                                                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '106px'
                                              }}
                                              onClick={(e) => { return this.handleLitigatorDetailModal(e, item.name); }}
                                              onKeyUp={(e) => { return this.handleLitigatorDetailModal(e, item.name); }}
                                            >
                                              <span>{item.name}</span>
                                            </li>
                                          );
                                        })
                                      }
                                    </ul>
                                  </Scrollbars>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="compare_box_2">
                                <div className="compare_box_header">
                                  <h4>
                                    <div className="block">
                                      {translate('modal.title.policy_name')}
                                    </div>
                                  </h4>
                                </div>
                                <div style={{ height: '206px' }}>
                                  <Scrollbars
                                    style={{
                                      overflow: 'hidden',
                                      position: 'relative',
                                      height: '84%'
                                    }}
                                    renderTrackHorizontal={() => {
                                      return <div />;
                                    }}
                                    renderThumbHorizontal={() => {
                                      return <div />;
                                    }}
                                    onScroll={this.handlePolicyScroll}
                                  >
                                    <ul>
                                      {
                                        compareResult.policies.list.map((item) => {
                                          return (
                                            <li
                                              className={cx('lit', {
                                                bg_red: item.belonged_to === 'source',
                                                bg_green: item.belonged_to === 'target',
                                              })}
                                              key={uuidv4()}
                                              style={{
                                                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '138px'
                                              }}
                                            >
                                              {item.name}
                                            </li>
                                          );
                                        })
                                      }
                                    </ul>
                                  </Scrollbars>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )
                : <Loader />
            }
            <div className="setting_popup_button_wrap">
              <a
                className="button save_button center_button"
                style={{ cursor: 'pointer' }}
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                {translate('modal.button.close')}
              </a>
            </div>
          </div>
        </div>
        <SecurityDetailModal
          isOpenMSD={isOpenMSD}
          closeModal={this.handleMSDClose}
          cveData={cveData}
          selectedCode={selectedCode}
        />
        <LitigatorDetailModal
          isOpenMLD={isOpenMLD}
          closeModal={this.handleMLDClose}
          litigatorData={litigatorData}
        />
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(CompareModal)));
